import {FormProvider, useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import React, {useEffect} from "react";
import BreadcrumbLayout from "@/components/common/CustomLayout/BreadcrumbLayout";
import './index.css'
import InvoiceTable from "@/pages/Invoice/Table";
import {RootState, useAppDispatch} from "@/store";
import {getInvoices} from "@/store/invoice/action";
import useCustomPaging from "@/hooks/useCustomPaging";
import useUserVenueSelectFilter from "@/hooks/useUserVenueSelectFilter";
import useSearchFilter from "@/hooks/useSearchFilter";
import {dynamicAttr} from "@/utils/fallback";
import {getUserVenues} from "@/store/user-info/action";
import useGenericSelectFilter from "@/hooks/useGenericSelectFilter";
import {statusOptions} from "@/pages/Invoice/constant";
import useDatePickerFilter from "@/hooks/useDatePickerFilter";
import GenericDatePicker from "@/components/common/GenericDatePicker";
import UserVenueSelect from "@/components/common/UserVenueSelect";
import GenericSelect from "@/components/common/GenericSelect";

const statusSelectOptions = statusOptions.map(s => ({
  value: s,
  label: s
}))

const Invoice = () => {
  const summaryMethods = useForm()
  const dispatch = useAppDispatch()
  const invoices = useSelector((state: RootState) => state.invoice.state.invoices)
  
  const [currentPageFilter] = useCustomPaging()
  const [
    currentVenueIdFilter,
    selectedVenue,
    venueOptions,
    handleChangeVenue,
  ] = useUserVenueSelectFilter()
  const [
    currentStatusFilter,
    selectedStatus,
    selectStatusOptions,
    handleChangeStatus,
  ] = useGenericSelectFilter('status', statusSelectOptions)
  const [
    createdDateTimestamp,
    currentSelectedDate,
    handleChangeDate
  ] = useDatePickerFilter('createdDate')
  const [
    searchString,
    currentSearchFilter,
    handleChangeSearchString,
    handleSubmitSearch
  ] = useSearchFilter()
  
  const getAllInvoices = () => {
    const params = {
      size: 10,
      ...dynamicAttr('page', currentPageFilter),
      ...dynamicAttr('venueId', currentVenueIdFilter),
      ...dynamicAttr('search', currentSearchFilter),
      ...dynamicAttr('status', currentStatusFilter),
      ...dynamicAttr('startDate', createdDateTimestamp)
    }
    dispatch(getInvoices(params))
  }

  useEffect(() => {
    dispatch(getUserVenues({}))
    getAllInvoices()
  }, [])

  useEffect(() => {
    getAllInvoices()
  }, [
    currentPageFilter,
    currentVenueIdFilter,
    currentSearchFilter,
    currentStatusFilter,
    createdDateTimestamp
  ])

  return (
    <BreadcrumbLayout>
      <FormProvider {...summaryMethods}>
        <div className="flex w-full flex-col gap-7">
          <div className="flex w-full justify-between">
            <div className="flex gap-4">
              <div className="text-j2xl font-bold">
                Invoices
              </div>
              <div className="separator"/>
              <UserVenueSelect
                name="venueId"
                id="venueId"
                placeholder="Select Venue"
                options={venueOptions}
                value={selectedVenue}
                onChange={handleChangeVenue}
              />
            </div>
            <div className="flex gap-4">
              <input
                value={searchString}
                onChange={handleChangeSearchString}
                onKeyDown={handleSubmitSearch}
                name="searchString"
                type="text"
                className="flex items-center py-[8px] px-4 gap-2 border rounded border-solid border-stroke-subtle text-jsm font-normal"
                placeholder="Search for Invoices"/>
              <div className="separator"/>
            </div>
          </div>
          <div className="card flex flex-col w-full">
            <div className="flex w-full justify-between py-4 px-6">
              <div className="flex gap-4 items-center">
                <div>
                  <GenericSelect
                    name="status"
                    id="status"
                    placeholder="Select Status"
                    options={selectStatusOptions}
                    value={selectedStatus}
                    onChange={handleChangeStatus}
                  />
                </div>
                <div className="separator"/>
                <div>
                  <GenericDatePicker
                    selected={currentSelectedDate}
                    onChange={handleChangeDate}
                  />
                </div>
              </div>
              <div className="flex justify-center items-center">
                10 per page
              </div>
            </div>
            <div>
              <InvoiceTable invoices={invoices} />
            </div>
          </div>
        </div>
      </FormProvider>
    </BreadcrumbLayout>
  )
};

export default Invoice;
